module.exports = __webpack_public_path__ + "static/media/USA.ea4bb1cb.svg";